import React from 'react';
import { styled } from '@compiled/react';
import { COMPAL_MENU_SCREEN_READER_ID } from '../constants.tsx';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const CommandPaletteScreenReaderContent: typeof ScreenReaderOnly = ({ ...props }) => (
	<ScreenReaderOnly
		aria-live="polite"
		aria-atomic="false"
		tabIndex={-1}
		{...props}
		id={COMPAL_MENU_SCREEN_READER_ID}
	/>
);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ScreenReaderOnly = styled.div({
	position: 'absolute',
	width: '1px',
	height: '1px',
	padding: 0,
	overflow: 'hidden',
	clip: 'rect(0, 0, 0, 0)',
	wordWrap: 'normal',
	border: 0,
});
